// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__2qGvt","line":"line__dCWmp"};


//////////////////
// WEBPACK FOOTER
// ./components/Magnetic/style.css
// module id = JbTr
// module chunks = 0